import { ProfilePageModules } from "..";

export const getProfileModuleName = (module: ProfilePageModules) => {
  switch (module) {
    case ProfilePageModules.archived_chats: {
      return 'profile:archived_chats.title';
    }
    case ProfilePageModules.language: {
      return 'profile:language.title';
    }
    case ProfilePageModules.my_posts: {
      return 'profile:my_posts.title';
    }
    case ProfilePageModules.notifications: {
      return 'profile:notifications.title';
    }
    case ProfilePageModules.user_settings: {
      return 'profile:user_settings.title';
    }
    case ProfilePageModules.privacy: {
      return 'profile:profile.privacy';
    }
    case ProfilePageModules.service: {
      return 'profile:profile.service';
    }
    case ProfilePageModules.wallet: {
      return 'profile:wallet.title';
    }
    case ProfilePageModules.default: {
      return 'profile:wallet.title';
    }
    default: {
      return 'profile:wallet.title';
    }
  }
};

